import { DeviceType, OS, UAData } from "../../types/Device";

const links = {
    [OS.IOS]: {
        [DeviceType.MOBILE]: "https://apps.apple.com/us/app/xola-phone/id1549263352",
        [DeviceType.TABLET]: "https://apps.apple.com/us/app/xola-tablet/id6458692258",
    },
    [OS.ANDROID]: {
        [DeviceType.MOBILE]: "https://play.google.com/store/apps/details?id=com.xola.seller.v2",
        [DeviceType.TABLET]: "https://play.google.com/store/apps/details?id=com.xola.xolatablet",
    },
};

export const getDownloadLink = (data: UAData): string | undefined => {
    // For iPad os getting recognized as Mac OS instead of iOS or iPadOS (tested on real device)
    const os = data.os.name === OS.MACOS ? OS.IOS : data.os.name;
    return links?.[os]?.[data.device.type];
};
